export default __webpack_public_path__ + "static/media/EditDetails.cfd69119.svg";